module.exports = __webpack_public_path__ + "static/default-c5599989ba9f0a73ac300928183dfe80.jpg";